define([
	'components/utilities/utilities',
	'./mobileMenu.template.hbs',
	'./mobileMenu.pane.template.hbs'
], function (utils, menuTemplate, paneTemplate) {
	'use strict';

	/**
	 * Mobile menu
	 * Javascript functionality for a (mobile) menu.
	 * @version 2.0.0
	 * @exports mobileMenu
	 */
	var mobileMenu = {

		/** Boolean indicating if the search-field should be rendered. */
		searchField: false,

		/** String with prefered search method. */
		searchMethod: 'GET',

		/** String with url to search page. */
		searchPage: '/search',

		/** String with the parameter name for searching. */
		searchParameter: 'query',

		/** String with the placeholder text for the search-field. */
		searchPlaceholder: 'Search',

		/** Object which will contain all panes in the menu. */
		menuPages: {},

		/** Placeholder for the pane holder. */
		paneHolder: null,

		/** Placeholder for the initial active menu pane. */
		activePane: null,

		/** Placeholder for the ajax path (if the menu should run with ajax). */
		ajaxPath: null,

		/** String with the id of the active pane (used for the initial ajax request). */
		ajaxActivePane: 'root',

		/** String with the active-class for page menu items. */
		activeClass: 'is-active',

		/** The page-container DOM element. */
		pageContainer: document.getElementById('page-container'),

		/** Placeholder for menu DOM element. */
		menuNode: null,

		/** Placeholder for the menu cover DOM element (covers the page when the menu is opened). */
		menuCoverNode: null,

		/** The menu button DOM element. */
		menuButtonNode: document.getElementById('menu-button'),


		/**
		 * The initialization function for this module.
		 * @param {Object} el - The page main menu as a DOM node.
		 * @param {Boolean} dontParse - Pass false if you don't want to parse the main menu.
		 * @public
		 */
		init: function (el, options) {
			utils.extend(this, options);
			this._renderMenu();

			if (this.ajaxPath === undefined || this.ajaxPath === false || this.ajaxPath === null || this.ajaxPath === '') {
				try {
					this._parseMenu(el);
				} catch (e) {}
			} else {
				this._initAjax();
			}

			this._initEvents();
		},


		/**
		 * Opens the menu.
		 * @public
		 */
		openMenu: function () {
			if (this.addVisibleClassInterval) {
				clearTimeout(this.addVisibleClassInterval);
			}
			this.menuNode.setAttribute('aria-hidden', false);
			this.menuButtonNode.setAttribute('aria-expanded', true);
			utils.addClass(document.getElementsByTagName('BODY')[0], 'nav-open');
			utils.addClass(document.getElementsByTagName('BODY')[0], 'nav-is-visible');
			this.addClassInterval = setTimeout(function () {
				utils.addClass(document.getElementsByTagName('BODY')[0], 'nav-opened');
			}, 100);
		},


		/**
		 * Closes the menu.
		 * @public
		 */
		closeMenu: function () {
			if (this.addClassInterval) {
				clearTimeout(this.addClassInterval);
			}
			this.menuNode.setAttribute('aria-hidden', true);
			this.menuButtonNode.setAttribute('aria-expanded', false);
			utils.removeClass(document.getElementsByTagName('BODY')[0], 'nav-open');
			utils.removeClass(document.getElementsByTagName('BODY')[0], 'nav-opened');
			this.addVisibleClassInterval = setTimeout(function () {
				utils.removeClass(document.getElementsByTagName('BODY')[0], 'nav-is-visible');
			}, 400);
		},


		/**
		 * Toggles the menu.
		 * @public
		 */
		toggleMenu: function () {
			if (this.menuNode.getAttribute('aria-hidden') === 'true') {
				this.openMenu();
			} else {
				this.closeMenu();
			}
		},


		/**
		 * Renders the mobile menu html.
		 * @private
		 */
		_renderMenu: function () {
			var menuHtml = menuTemplate({ searchField: this.searchField, searchMethod: this.searchMethod, searchPage: this.searchPage, searchParameter: this.searchParameter, searchPlaceholder: this.searchPlaceholder });
			document.getElementsByTagName('BODY')[0].insertAdjacentHTML('BeforeEnd', menuHtml);
			this.menuNode = document.getElementById('mobile-menu');
			this.menuCoverNode = document.getElementById('mobile-menu-page-cover');
			this.paneHolder = document.getElementById('mobile-menu-paneholder');
			utils.addClass(this.pageContainer, 'mobile-menu-slideout');
		},


		/**
		 * Renders the html for a pane.
		 * @private
		 */
		_renderMenuPane: function (pane, place) {
			var paneHtml = paneTemplate(pane);
			this.paneHolder.insertAdjacentHTML(place || 'BeforeEnd', paneHtml);
		},


		/**
		 * Parses the page menu and create mobile menu panes.
		 * @param {Object} el - The page main menu as a DOM node.
		 * @private
		 */
		_parseMenu: function (el) {
			var parser = new DOMParser(),
				html = utils.stripTags(el.innerHTML, '<ul><li><a><span>'),
				doc = parser.parseFromString(html, 'text/html'),
				jsonData = { items: this._parsePageMenus(doc.querySelectorAll('.menu-item-holder-top, .language-select, .login-logout')) };

			this._generateMenuPages(jsonData.items, 'root');

			for (var key in this.menuPages) {
				if (this.menuPages.hasOwnProperty(key)) {
					this._renderMenuPane(this.menuPages[key]);
				}
			}

			if (this.activePane === null || this.activePane === 'root') {
				this.activePane = 'root';
			}
			this._openMenuPane(document.getElementById('mobile-menu-pane-' + this.activePane));
		},


		_parsePageMenus: function (menus) {
			var menusArray = Array.prototype.slice.call(menus, 0);
			menusArray.sort(function (a, b) {
				return a.dataset.mobilesort - b.dataset.mobilesort;
			});
			var menuItems = [];
			for (var i = 0; i < menusArray.length; i++) {
				var arr = this._parsePageMenu(menusArray[i]);
				menuItems = menuItems.concat(arr);
			}
			for (var b = 0; b < menuItems.length; b++) {
				menuItems[b].link.classlist = menuItems[b].link.classlist.replace(new RegExp('(^|\\b)' + 'btn' + '(\\b|$)', 'gi'), ' ');
			}
			return menuItems;
		},


		/**
		 * Recursivly parses the page menu and collect all ul/li/a.
		 * @param {Object} el - A DOM node to parse.
		 * @param {Object} parentObj - The parent DOM node.
		 * @private
		 */
		_parsePageMenu: function (obj, parentObj) {
			var that = this,
				json = [];

			if (obj.hasChildNodes()) {
				var child = obj.firstChild;

				while (child) {
					if (child.nodeType === 1) {
						var tag = { node: child.tagName, classlist: child.getAttribute('class') || '' };
						if (child.tagName === 'A') {
							tag.text = child.textContent || child.innerText;
							tag.url = child.getAttribute('href');
							parentObj.link = tag;
						} else if (child.tagName === 'SPAN') {
							tag.text = child.textContent || child.innerText;
							tag.url = '#';
							parentObj.link = tag;
						} else {
							if (child.tagName === 'UL') {
								tag.ul = true;
							}
							tag.items = that._parsePageMenu(child, tag);
							json.push(tag);
						}
					}
					child = child.nextSibling;
				}
			}
			return json;
		},


		/**
		 * Generate panes for each submenu (recursive).
		 * @param {Object[]} arr - Array of items.
		 * @param {Object} itemParent - The parent item.
		 * @param {Object} paneParent - The parent pane item.
		 * @private
		 */
		_generateMenuPages: function (arr, itemParent, paneParent, parentItemName) {
			var that = this,
				parentName = '';

			utils.forEach(arr, function (item, i) {
				if (item.node === 'LI') {
					item.parent = itemParent;
					item.id = itemParent + '-' + i;
					if (that.menuPages[itemParent] === undefined) {
						that.menuPages[itemParent] = {
							id: itemParent,
							parent: paneParent || null,
							parentName: parentItemName || '',
							items: []
						};
					}
					that.menuPages[itemParent].items.push(item);
					if (item.link !== undefined) {
						parentName = item.link.text;
						if (item.link.classlist.indexOf(that.activeClass) !== -1) {
							that.activePane = itemParent;
						}
					}
				} else {
					item.id = itemParent;
					itemParent = paneParent;
					parentName = parentItemName;
				}

				if (item.items.length > 0) {
					that._generateMenuPages(item.items, item.id, itemParent, parentName);
				}
			});
		},


		/**
		 * Opens a submenu (pane).
		 * @param {Object} pane - The pane to be opened as a DOM node.
		 * @private
		 */
		_openMenuPane: function (pane) {
			var activeMenuLinks = this.menuNode.querySelectorAll('[aria-expanded="true"]'),
				activePane = this.menuNode.querySelector('.is-active-pane'),
				ancestor;

			if (activePane !== null) {
				activePane.setAttribute('aria-hidden', true);
			}
			if (activeMenuLinks.length > 0) {
				utils.forEach(activeMenuLinks, function (activeMenuLink) {
					activeMenuLink.setAttribute('aria-expanded', false);
				});
			}
			pane.setAttribute('aria-hidden', false);
			utils.forEachElement('[data-target="' + pane.id + '"]', function (link) {
				link.setAttribute('aria-expanded', true);
			});

			ancestor = document.getElementById('mobile-menu-pane-' + pane.getAttribute('data-parent'));
			while (ancestor !== null) {
				utils.addClass(ancestor, 'is-active-trail-pane');
				ancestor = document.getElementById('mobile-menu-pane-' + ancestor.getAttribute('data-parent'));
			}

			if (activePane !== null) {
				utils.removeClass(activePane, 'is-active-pane');
			}
			utils.removeClass(pane, 'is-active-trail-pane');
			utils.addClass(pane, 'is-active-pane');
		},


		/**
		 * Initiate ajax.
		 * @private
		 */
		_initAjax: function () {
			var that = this;

			require(['libs/nanoajax'], function (nanoajax) {
				that.nanoajax = nanoajax;
				that._loadMenu(that.ajaxActivePane);
			});
		},


		/**
		 * Loads a menuPane through ajax.
		 * @private
		 */
		_loadMenu: function (id) {
			var that = this,
				requestUrl = this.ajaxPath.indexOf('?') === -1 ? this.ajaxPath + '?id=' + id : this.ajaxPath + '&id=' + id;

			this.nanoajax.ajax({
				method: 'GET',
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				},
				url: requestUrl
			},
			function (code, data) {
				var loadingLink = that.menuNode.querySelector('.is-loading'),
					activePane;

				if (code === 200) {
					data = JSON.parse(data);
					if (data.d !== undefined) {
						data = data.d;
					}

					// This is needed to get ajax back links to animate correctly.
					activePane = that.menuNode.querySelector('.is-active-pane');
					if (activePane !== null && activePane.getAttribute('data-parent') === data.id) {
						data.classlist = 'is-active-trail-pane';
						that._renderMenuPane(data, 'AfterBegin');
					} else {
						that._renderMenuPane(data);
					}

					setTimeout(function () {
						that._openMenuPane(document.getElementById('mobile-menu-pane-' + data.id));
					}, 10);
				} else {
					alert('An error occured, try again later.');
				}

				if (loadingLink !== null) {
					utils.removeClass(loadingLink, 'is-loading');
				}
			});
		},


		/**
		 * Initiate events.
		 * @private
		 */
		_initEvents: function () {
			var that = this;

			utils.addEventListener(this.menuButtonNode, 'click', function (event) {
				if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
				that.toggleMenu();
			});

			utils.addEventListener(this.menuCoverNode, 'click', function (event) {
				if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
				that.closeMenu();
			});

			utils.addEventListener(document, 'click', function (event) {
				var link = event.target;

				// Normal navigation
				if (utils.hasClass(link, 'mobile-menu-nav')) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

					if (document.getElementById(link.getAttribute('aria-controls')) !== null) {
						that._openMenuPane(document.getElementById(link.getAttribute('aria-controls')));
					}
					else if (that.ajaxPath) {
						utils.addClass(link, 'is-loading');
						that._loadMenu(link.getAttribute('data-target'));
					} else {
						alert('An error occured, try again later.');
					}
				}
			});
		}
	};


	return mobileMenu;
});



//////////////////
// WEBPACK FOOTER
// ./components/mobileMenu/mobileMenu.js
// module id = 6
// module chunks = 0